import Services from './base-services'

const service = new Services('textType')

export default {
    getAll() {
        return service.get('getAll', { params: { showGenresWithBooks: true } })
    },
}
